var map = {
	"./logo-light-1.png": 58,
	"./logo-light-2.png": 59,
	"./logo-light-3.png": 60,
	"./logo-light-4.png": 61,
	"./logo-light-5.png": 62,
	"./logo-light-6.png": 63,
	"./logo-light-7.png": 64,
	"./logo-light-8.png": 65
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 57;